/* PawMarket — Bold V2 sections (ported). Single-init guarded; Theme Editor aware. */
(function () {
  'use strict';
  if (window.__pmHomeInit) return;
  window.__pmHomeInit = true;

  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* Hero line rise once fonts are ready */
  function markLoaded() { document.body.classList.add('loaded'); }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(markLoaded);
    setTimeout(markLoaded, 1200); /* safety */
  } else { markLoaded(); }

  /* ---------- Scroll reveals ---------- */
  var io = null;
  if ('IntersectionObserver' in window && !designMode) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }
  function initReveals(root) {
    root.querySelectorAll('.rv').forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('in'); }
    });
  }

  /* ---------- Spotlight: activate step + swap image ---------- */
  function initSpotlight(root) {
    root.querySelectorAll('[data-pm-spotlight]').forEach(function (spot) {
      var steps = Array.prototype.slice.call(spot.querySelectorAll('.spot-step'));
      var imgs = Array.prototype.slice.call(spot.querySelectorAll('[data-step-img]'));
      if (!steps.length) return;
      function setStep(i) {
        steps.forEach(function (s, k) { s.classList.toggle('active', k === i); });
        imgs.forEach(function (m, k) { m.classList.toggle('active', k === i); });
      }
      if ('IntersectionObserver' in window) {
        var sio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) setStep(steps.indexOf(e.target));
          });
        }, { rootMargin: '-42% 0px -42% 0px' });
        steps.forEach(function (s) { sio.observe(s); });
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    root.querySelectorAll('.faq-q').forEach(function (btn) {
      if (btn.__pmBound) return;
      btn.__pmBound = true;
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Finder — signature interactive moment ---------- */
  function initFinder(root) {
    root.querySelectorAll('[data-pm-finder]').forEach(function (finder) {
      if (finder.__pmBound) return;
      finder.__pmBound = true;
      var dataEl = finder.querySelector('[data-pm-finder-data]');
      var cfg;
      try { cfg = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var stepPet = finder.querySelector('[data-step="pet"]');
      var stepNeed = finder.querySelector('[data-step="need"]');
      var stepResult = finder.querySelector('[data-step="result"]');
      function show(el) {
        [stepPet, stepNeed, stepResult].forEach(function (s) { s.classList.remove('on'); });
        el.classList.add('on');
      }
      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      }
      finder.addEventListener('click', function (ev) {
        var petBtn = ev.target.closest('[data-pet]');
        var needBtn = ev.target.closest('[data-pick]');
        var backBtn = ev.target.closest('[data-back]');
        if (petBtn && petBtn.hasAttribute('data-pet')) {
          var pet = petBtn.getAttribute('data-pet');
          var opts = cfg.options.filter(function (o) { return o.pet === pet; }).map(function (o) {
            return '<button class="f-opt" data-pick="' + esc(o.id) + '"><span class="emoji">' + esc(o.emoji) + '</span>' + esc(o.label) + '<small>' + esc(o.small) + '</small></button>';
          }).join('');
          stepNeed.innerHTML =
            '<button class="f-back" data-back="pet">← Back</button>' +
            '<p class="f-q">' + esc(cfg.q2) + '</p>' +
            '<div class="f-opts">' + opts + '</div>';
          show(stepNeed);
        } else if (needBtn) {
          var p = null;
          cfg.options.forEach(function (o) { if (o.id === needBtn.getAttribute('data-pick')) p = o; });
          if (!p) return;
          stepResult.innerHTML =
            '<button class="f-back" data-back="need">← Back</button>' +
            '<div class="f-result">' +
              '<div class="f-result-media"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '"' + (p.fit === 'contain' ? ' class="fit-contain"' : '') + ' loading="lazy"></div>' +
              '<div class="f-result-body">' +
                '<span class="f-match">' + esc(cfg.match_label) + '</span>' +
                '<h3>' + esc(p.name) + '</h3>' +
                '<p class="f-why">' + esc(p.why) + '</p>' +
                '<p class="f-price">' + esc(p.price) + (p.was ? ' <s>' + esc(p.was) + '</s>' : '') + '</p>' +
                '<a class="btn btn-fill" href="' + esc(p.url) + '">' + esc(cfg.cta_label) + ' <span class="arr">→</span></a>' +
              '</div>' +
            '</div>';
          show(stepResult);
        } else if (backBtn) {
          show(backBtn.getAttribute('data-back') === 'pet' ? stepPet : stepNeed);
        }
      });
    });
  }

  function initScope(root) {
    initReveals(root);
    initSpotlight(root);
    initFaq(root);
    initFinder(root);
  }

  function boot() { initScope(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Theme Editor: re-init sections after they are re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
    initScope(e.target);
  });
})();
